import { createContext } from 'react';

export const ConfigContext = createContext<Config>(null);

export const { Provider: ConfigProvider } = ConfigContext;
